// ----------------------------------------------------------------------------
// Snippet: Background Media
// ----------------------------------------------------------------------------
//
// Modal poopup
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_background-media.scss';
import './_background-image--overlay.scss';